import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ro from './locales/ro.json'
import en from './locales/en.json'

// i18next setup for BBSO Excelență.
//
// Order of language detection (first match wins):
//   1. localStorage ('bbso_lang')      — persisted by the in-app switcher
//   2. fallback to 'ro'                — primary language of the site
//
// Browser/navigator detection is deliberately NOT in the order: new visitors
// always land in Romanian regardless of their browser locale. They can opt
// into English via the header switcher, and that choice is persisted to
// localStorage so subsequent visits remember it.
//
// Once the user logs in, the AuthContext will call i18n.changeLanguage(user.language)
// so emails + UI stay in sync with the user's saved preference.

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    supportedLngs: ['ro', 'en'],
    fallbackLng: 'ro',
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'bbso_lang',
      caches: ['localStorage'],
    },
  })

export default i18n
